"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _useOnclickoutside = _interopRequireDefault(require("use-onclickoutside"));

var _useOnPressEsc = _interopRequireDefault(require("../../../utils/hooks/useOnPressEsc"));

var _overrides = require("../../../utils/overrides");

var _ValueContainer = _interopRequireDefault(require("./ValueContainer"));

var _utils = require("./utils");

var _Select = _interopRequireDefault(require("../Select"));

var _styles = require("../../../utils/styles");

var _styles2 = _interopRequireDefault(require("./styles"));

var useStyles = (0, _styles.createUseStyles)(_styles2.default, 'SelectButton');

function SelectButton(_ref) {
  var children = _ref.children,
      classesProp = _ref.classes,
      overridesProp = _ref.overrides,
      classNameProp = _ref.className,
      onChange = _ref.onChange,
      button = _ref.button,
      id = _ref.id,
      name = _ref.name,
      options = _ref.options,
      value = _ref.value,
      placeholder = _ref.placeholder,
      noOptionsPlaceholder = _ref.noOptionsPlaceholder,
      hint = _ref.hint,
      error = _ref.error,
      isRequired = _ref.isRequired,
      isReadOnly = _ref.isReadOnly,
      isMulti = _ref.isMulti,
      components = _ref.components,
      hideOptions = _ref.hideOptions,
      actions = _ref.actions,
      props = (0, _objectWithoutProperties2.default)(_ref, ["children", "classes", "overrides", "className", "onChange", "button", "id", "name", "options", "value", "placeholder", "noOptionsPlaceholder", "hint", "error", "isRequired", "isReadOnly", "isMulti", "components", "hideOptions", "actions"]);
  var classes = (0, _overrides.useClasses)(useStyles, classesProp); // State

  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      isOpen = _useState2[0],
      setIsOpen = _useState2[1]; // Hooks
  // Closing select


  var ref = (0, _react.useRef)(null);
  (0, _useOnclickoutside.default)(ref, function (e) {
    var optionEl = (0, _utils.checkPathTarget)(e.target, 'hoi-poi-select__option');
    var actionEl = (0, _utils.checkPathTarget)(e.target, 'hoi-poi-select__action');
    if (!optionEl && !actionEl) setIsOpen(false);
  });
  (0, _useOnPressEsc.default)(function () {
    return setIsOpen(false);
  });
  var onSelectChange = (0, _react.useCallback)(function () {
    onChange && onChange.apply(void 0, arguments);
    setIsOpen(false);
  }, [onChange]);
  var toggleOpen = (0, _react.useCallback)(function () {
    setIsOpen(!isOpen);
  }, [isOpen]); // Overrides

  var override = (0, _overrides.getOverrides)(overridesProp, SelectButton.overrides); // Classes

  var rootClassName = (0, _classnames.default)(classes.root, classNameProp);
  var rootProps = (0, _extends2.default)({
    className: rootClassName
  }, override.root);
  var selectProps = (0, _extends2.default)({
    id: id,
    name: name,
    hint: hint,
    placeholder: placeholder,
    options: options,
    value: value,
    hideOptions: hideOptions,
    noOptionsPlaceholder: noOptionsPlaceholder,
    onChange: onSelectChange,
    isMulti: isMulti,
    actions: actions,
    onClickAction: toggleOpen
  }, override.Select);
  return /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({}, rootProps, {
    ref: ref
  }), /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({
    className: classes.button
  }, override.button, {
    onClick: toggleOpen
  }), children), isOpen && /*#__PURE__*/_react.default.createElement(_Select.default, (0, _extends2.default)({
    className: classes.select,
    menuClassName: classes.menu,
    menuListClassName: classes.menuList
  }, selectProps, {
    components: {
      ValueContainer: _ValueContainer.default,
      DropdownIndicator: null
    },
    overrides: {
      'react-select': {
        isClearable: false,
        autoFocus: true,
        controlShouldRenderValue: false,
        backspaceRemovesValue: false,
        tabSelectsValue: false,
        menuIsOpen: true
      }
    }
  })));
}

SelectButton.overrides = ['root', 'Select', 'button'];
SelectButton.defaultProps = {
  onChange: function onChange() {},
  value: '',
  isReadOnly: false,
  hideOptions: true,
  isClearable: true,
  isMulti: false
};
process.env.NODE_ENV !== "production" ? SelectButton.propTypes = {
  className: _propTypes.default.string,
  overrides: _propTypes.default.object,
  onChange: _propTypes.default.func,

  /** Native input id */
  id: _propTypes.default.string,

  /** Native input name */
  name: _propTypes.default.string,
  options: _propTypes.default.arrayOf(_propTypes.default.shape({
    label: _propTypes.default.string,
    value: _propTypes.default.any,
    isDisabled: _propTypes.default.bool
  })),
  value: _propTypes.default.any,
  placeholder: _propTypes.default.string,
  noOptionsPlaceholder: _propTypes.default.string,
  error: _propTypes.default.string,

  /** Hide the selected option from the menu */
  hideSelectedOptions: _propTypes.default.bool,

  /** multiple select support */
  isMulti: _propTypes.default.bool,

  /** Fixed actions added at the bottom of menu list */
  actions: _propTypes.default.arrayOf(_propTypes.default.shape({
    label: _propTypes.default.string,
    onClick: _propTypes.default.func
  }))
} : void 0;

var _default = /*#__PURE__*/_react.default.memo(SelectButton);

exports.default = _default;